var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tags"},_vm._l((_vm.tags),function(tag,i){return _c('span',{staticClass:"tag"},[_vm._v("#"+_vm._s(tag.replace(/ /g,"_").toLowerCase())+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }